
const CircleCheck = () => {
    return (
        <svg aria-hidden width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6165_29116)">
                <rect width="80" height="80" fill="white" fillOpacity="0.01" />
                <rect width="80" height="80" rx="40" fill="#228830" fillOpacity="0.12" />
                <g clipPath="url(#clip1_6165_29116)">
                    <g clipPath="url(#clip2_6165_29116)">
                        <path
                            d="M40 62C52.1516 62 62 52.1516 62 40C62 27.8484 52.1516 18 40 18C27.8484 18 18 27.8484 18 40C18 52.1516 27.8484 62 40 62ZM49.7109 35.9609L38.7109 46.9609C37.9031 47.7687 36.5969 47.7687 35.7977 46.9609L30.2977 41.4609C29.4898 40.6531 29.4898 39.3469 30.2977 38.5477C31.1055 37.7484 32.4117 37.7398 33.2109 38.5477L37.25 42.5867L46.7891 33.0391C47.5969 32.2312 48.9031 32.2312 49.7023 33.0391C50.5016 33.8469 50.5102 35.1531 49.7023 35.9523L49.7109 35.9609Z"
                            fill="#228830"
                        />
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_6165_29116">
                    <rect width="80" height="80" fill="white" />
                </clipPath>
                <clipPath id="clip1_6165_29116">
                    <rect width="44" height="44" fill="white" transform="translate(18 18)" />
                </clipPath>
                <clipPath id="clip2_6165_29116">
                    <rect width="44" height="44" fill="white" transform="translate(18 18)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default CircleCheck;
